module.exports = __webpack_public_path__ + "img/image-upload.a512021d.svg";